import { Link } from "react-router-dom";
import { Heart, Building2 } from "lucide-react";

const GetStarted = () => {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      {/* Header */}
      <div className="px-4 py-4 flex justify-center">
        <Link to="/" className="opacity-70 hover:opacity-100 transition-opacity">
          <img src="/ll-mark-256.png" alt="LegacyLens AI" className="h-24" />
        </Link>
      </div>

      {/* Content */}
      <div className="flex-1 flex items-center justify-center px-4 pb-16">
        <div className="max-w-2xl w-full">
          <div className="text-center mb-10">
            <h1 className="font-display text-3xl sm:text-4xl font-bold text-foreground mb-3">
              How would you like to get started?
            </h1>
            <p className="text-muted-foreground text-lg">
              Choose the option that best describes you.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 gap-5">
            {/* Family option */}
            <Link
              to="/pricing"
              className="group block rounded-2xl border border-border/50 bg-card/60 backdrop-blur-sm p-8 text-center hover:border-primary/40 hover:shadow-lg transition-all duration-200"
            >
              <div className="w-14 h-14 rounded-xl bg-primary/10 flex items-center justify-center mx-auto mb-5 group-hover:bg-primary/20 transition-colors">
                <Heart className="w-7 h-7 text-primary" />
              </div>
              <h2 className="font-display text-xl font-semibold text-foreground mb-2">
                I'm a Family
              </h2>
              <p className="text-sm text-muted-foreground leading-relaxed">
                Create a digital tribute experience for a loved one with 3D experiences, AI conversation, and QR code access.
              </p>
            </Link>

            {/* Funeral home partner option */}
            <Link
              to="/partner"
              className="group block rounded-2xl border border-border/50 bg-card/60 backdrop-blur-sm p-8 text-center hover:border-primary/40 hover:shadow-lg transition-all duration-200"
            >
              <div className="w-14 h-14 rounded-xl bg-primary/10 flex items-center justify-center mx-auto mb-5 group-hover:bg-primary/20 transition-colors">
                <Building2 className="w-7 h-7 text-primary" />
              </div>
              <h2 className="font-display text-xl font-semibold text-foreground mb-2">
                I'm an Ancestry/Genealogy Partner, Funeral Home, or Cemetery
              </h2>
              <p className="text-sm text-muted-foreground leading-relaxed">
                Offer interactive digital tributes to the families you serve. Join as a founding partner.
              </p>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GetStarted;
